import React from 'react';
import TitleBar from '../../components/TitleBar/TitleBar';

interface TitleBarContainerProps {
  onSettingsVisibilityChange: (isVisible: boolean) => void;
  onSave?: () => void;
  onLoginClick: () => void;
  onRegisterClick: () => void;
}

const TitleBarContainer: React.FC<TitleBarContainerProps> = ({ 
  onSettingsVisibilityChange, 
  onSave, 
  onLoginClick, 
  onRegisterClick 
}) => {
  const handleMinimize = () => window.electron.ipcRenderer.invoke('window-minimize');
  const handleMaximize = () => window.electron.ipcRenderer.invoke('window-maximize');
  const handleClose = () => window.electron.ipcRenderer.invoke('window-close');

  return (
    <TitleBar
      onMinimize={handleMinimize}
      onMaximize={handleMaximize}
      onClose={handleClose}
      onOpenSettings={() => onSettingsVisibilityChange(true)}
      onOpenFolder={() => {}}
      onNewFile={() => {}}
      onNewFolder={() => {}}
      onRefresh={() => {}}
      onCollapseAll={() => {}}
      onSave={onSave}
      onLoginClick={onLoginClick}
      onRegisterClick={onRegisterClick}
    />
  );
};

export default TitleBarContainer; 